import { PoWiseOrderQtyModel } from "../order-completion-qty/po-wise-order-qty.model";
import { StyleWiseOpCompletionModel } from "./style-wise-op-completion.model";


export class BuyerWiseOpCompletionModel {
    buyer: string;
    styleOpCompletionInfo: StyleWiseOpCompletionModel[];
    poWiseFullPlanQtys: PoWiseOrderQtyModel[];

    constructor(buyer: string, styleOpCompletionInfo: StyleWiseOpCompletionModel[], poWiseFullPlanQtys: PoWiseOrderQtyModel[]) {
        this.buyer = buyer;
        this.styleOpCompletionInfo = styleOpCompletionInfo;
        this.poWiseFullPlanQtys = poWiseFullPlanQtys;
    }
}


